import { CircularProgress, Stack, Typography } from "@mui/material";

const LoadingRTStructTPS = () => {
  return (
    <Stack
      sx={{
        alignItems: "center",
        gap: 1,
      }}
    >
      <CircularProgress color="primary" />
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
        }}
      >
        Retrieving RTStruct from TPS...
      </Typography>
    </Stack>
  );
};

export default LoadingRTStructTPS;
